import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { TbFlagCog, TbFlagHeart, TbFlagSearch } from "react-icons/tb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer, message } from "antd";
import { useEffect, useState } from "react";
import { BsGridFill, BsPersonHeart } from "react-icons/bs";
import {
  FaBuilding,
  FaCompass,
  FaCog,
  FaEnvelopeOpenText,
  FaHeadset,
  FaLink,
  FaUser,
  FaUserFriends,
  FaCreditCard,
} from "react-icons/fa";
import { MdOutlineLogout } from "react-icons/md";
import { NavLink, Redirect, Route, useHistory } from "react-router-dom";
import Router from ".";
import logo from "../images/SurfingCre2.png";
import { useUserStore } from "../stores/userStore";
import { FaPeopleGroup } from "react-icons/fa6";

const Header = ({ onMenuClick }) => {
  const history = useHistory();

  return (
    <div className="h-20 md:h-28 text-white flex items-center justify-between py-2 md:py-2.5 px-3 md:px-10 bg-[#171717]">
      <div className="flex items-center flex-1 md:flex-none">
        <button
          onClick={onMenuClick}
          className="md:hidden flex items-center justify-center w-10 h-10 p-0 border-0 cursor-pointer rounded-full bg-transparent text-white mr-3"
        >
          <FontAwesomeIcon icon={faBars} className="w-7 h-7" />
        </button>
        <button
          onClick={() => history.push("/home")}
          className="shrink-0 cursor-pointer"
        >
          <img src={logo} alt="SurfingCre 로고" className="h-7 md:h-8" />
        </button>
      </div>

      <div className="flex items-center gap-4 md:gap-8">
        <Router.LanguageTranslator />
        <div>
          <Router.Alarm />
        </div>
        <button
          className="flex items-center justify-center p-0 border-0 cursor-pointer rounded-full bg-transparent text-white"
          onClick={() => {
            localStorage.clear();
            history.push("/signin");
          }}
          title="Logout"
        >
          <MdOutlineLogout className="w-9 h-9 md:w-12 md:h-12" />
        </button>
      </div>
    </div>
  );
};

export const Lnb = ({ isMobile = false, onMenuClick }) => {
  const { userInfo } = useUserStore();
  const userType = userInfo?.user_info?.user_type;

  const SectionTitle = ({ children }) => (
    <div className="text-[11px] font-bold tracking-wider text-[#888] mt-6 mb-1 mx-[15px] px-5">
      {children}
    </div>
  );
  const activeStyle = {
    display: "flex",
    alignItems: "center",
    color: "#fff",
    backgroundColor: "#171717",
  };

  const NavItem = ({ to, icon: Icon, children, isMobile, onMenuClick }) => (
    <li className="h-[50px] mb-[5px]">
      <NavLink
        to={to}
        className="mx-[15px] px-5 flex items-center h-full rounded-[10px] cursor-pointer text-[#171717] hover:bg-[#e6e6e6] hover:text-[#171717]"
        activeStyle={activeStyle}
        onClick={isMobile ? onMenuClick : undefined}
      >
        <span className="w-6 h-6 flex items-center justify-center mr-4 flex-shrink-0">
          <Icon size={16} />
        </span>
        {children}
      </NavLink>
    </li>
  );

  return (
    <div
      className={`z-[1] h-full font-medium pt-[24px] flex flex-col overflow-y-auto ${
        isMobile
          ? "w-full border-0 bg-white"
          : "w-[230px] border-r border-[#d9d9d9] bg-white shadow flex-shrink-0"
      }`}
    >
      <ul className="flex-1">
        <NavItem
          to="/home"
          icon={BsGridFill}
          isMobile={isMobile}
          onMenuClick={onMenuClick}
        >
          대시보드
        </NavItem>

        {userType === "brand" && (
          <>
            <li>
              <SectionTitle>크리에이터</SectionTitle>
            </li>
            <NavItem
              to="/influencer/search"
              icon={FaCompass}
              isMobile={isMobile}
              onMenuClick={onMenuClick}
            >
              크리에이터 찾기
            </NavItem>
            <li className="mb-[5px]">
              <SectionTitle>캠페인</SectionTitle>
              <ul className="pb-2">
                <NavItem
                  to="/campaign/manage"
                  icon={TbFlagCog}
                  isMobile={isMobile}
                  onMenuClick={onMenuClick}
                >
                  캠페인 관리
                </NavItem>
              </ul>
            </li>
          </>
        )}

        {userType === "agency" && (
          <li className="mb-[5px]">
            <SectionTitle>캠페인</SectionTitle>
            <ul className="pb-2">
              <NavItem
                to="/campaign/search"
                icon={TbFlagSearch}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                캠페인 찾기
              </NavItem>
              <NavItem
                to="/campaign/manage"
                icon={TbFlagCog}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                캠페인 관리
              </NavItem>
            </ul>
          </li>
        )}

        {userType === "influencer" && (
          <li className="mb-[5px]">
            <SectionTitle>캠페인</SectionTitle>
            <ul className="pb-2">
              <NavItem
                to="/campaign/search"
                icon={TbFlagSearch}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                캠페인 찾기
              </NavItem>
              <NavItem
                to="/campaign/manage"
                icon={TbFlagHeart}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                나의 캠페인
              </NavItem>
            </ul>
          </li>
        )}

        {(userType === "brand" || userType === "agency") && (
          <li className="mb-[5px]">
            <SectionTitle>워크스페이스</SectionTitle>
            <ul className="pb-2">
              <NavItem
                to="/workspace/info"
                icon={FaBuilding}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                {userType === "brand" ? "브랜드" : "에이전시"} 정보
              </NavItem>
              <NavItem
                to="/workspace/members-management"
                icon={FaUserFriends}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                멤버 관리
              </NavItem>
              {userType === "agency" && (
                <NavItem
                  to="/workspace/creator-management"
                  icon={FaPeopleGroup}
                  isMobile={isMobile}
                  onMenuClick={onMenuClick}
                >
                  크리에이터 관리
                </NavItem>
              )}
            </ul>
          </li>
        )}

        {userType === "influencer" && (
          <li className="mb-[5px]">
            <SectionTitle>내 크리에이터 설정</SectionTitle>
            <ul className="pb-2">
              <NavItem
                to="/influencer/profile"
                icon={BsPersonHeart}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                크리에이터 정보
              </NavItem>
              <NavItem
                to="/influencer/dashboard"
                icon={FaLink}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                소셜 연동 정보
              </NavItem>
            </ul>
          </li>
        )}

        <li className="mb-[5px]">
          <SectionTitle>회원정보</SectionTitle>
          <ul className="pb-2">
            <NavItem
              to="/mypage/profile"
              icon={FaUser}
              isMobile={isMobile}
              onMenuClick={onMenuClick}
            >
              내 정보
            </NavItem>
            {userType === "influencer" && (
              <>
                <NavItem
                  to="/mypage/invitations"
                  icon={FaEnvelopeOpenText}
                  isMobile={isMobile}
                  onMenuClick={onMenuClick}
                >
                  초대 목록
                </NavItem>
                <NavItem
                  to="/payments/influencer-payments-history"
                  icon={FaCreditCard}
                  isMobile={isMobile}
                  onMenuClick={onMenuClick}
                >
                  정산 내역
                </NavItem>
              </>
            )}
            {userType === "agency" && (
              <NavItem
                to="/payments/agency-payments-history"
                icon={FaCreditCard}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                정산 내역
              </NavItem>
            )}
            {userType === "brand" && (
              <NavItem
                to="/payments/brand-payments-history"
                icon={FaCreditCard}
                isMobile={isMobile}
                onMenuClick={onMenuClick}
              >
                결제 내역
              </NavItem>
            )}
            <NavItem
              to="/mypage/settings"
              icon={FaCog}
              isMobile={isMobile}
              onMenuClick={onMenuClick}
            >
              계정 설정
            </NavItem>
          </ul>
        </li>

        <li>
          <SectionTitle>고객 지원</SectionTitle>
        </li>
        <NavItem
          to="/support"
          icon={FaHeadset}
          isMobile={isMobile}
          onMenuClick={onMenuClick}
        >
          고객지원
        </NavItem>
      </ul>

      {/* {userType === "brand" && (
        <NavLink
          to="/membership"
          className="p-5 mx-4 mb-6 rounded-xl bg-[#fafafa]
            flex flex-col items-center gap-2 cursor-pointer no-underline hover:bg-[#fafafa]"
          onClick={isMobile ? onMenuClick : undefined}
        >
          <BsStars size={22} className="text-yellow-500" />
          <span className="text-lg font-semibold text-[#2c2c2c]">
            멤버십 구독하기
          </span>
          <span className="text-sm text-gray-500 text-center leading-tight">
            멤버십으로 더 많은 인사이트와 <br />
            효율적인 비즈니스 운영을 시작해보세요.
          </span>
        </NavLink>
      )} */}
    </div>
  );
};

export const Main = () => {
  const { loadUserInfo, userInfo } = useUserStore();
  const history = useHistory();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [channelMessengerOpen, setChannelMessengerOpen] = useState(false);

  useEffect(() => {
    loadUserInfo();
    if (history.location.pathname === "/") {
      history.replace("/home");
    }
  }, [history, loadUserInfo]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileMenuOpen]);

  // 채널톡
  useEffect(() => {
    // 스크립트 로드
    ChannelService.loadScript();

    // userInfo가 로드된 후에만 채널톡 부팅
    if (userInfo?.user_info) {
      const isBrand = userInfo.user_info.user_type === "brand";
      const settings = {
        pluginKey: "8bf25d68-f6fa-45bd-8b80-cfdb13844720",
        zIndex: 999999,
        hideChannelButtonOnBoot: isBrand,
        memberId: userInfo.user_info.id,
        profile: {
          name:
            userInfo.user_info.first_name + " " + userInfo.user_info.last_name,
          mobileNumber: userInfo.user_info.phone,
          email: userInfo.user_info.email,
        },
      };

      ChannelService.boot(settings);
      ChannelService.onShowMessenger(() => setChannelMessengerOpen(true));
      ChannelService.onHideMessenger(() => setChannelMessengerOpen(false));
      // ChannelService.setAppearance("dark");

      ChannelService.onChatCreated(function onChatCreated() {
        Router.Api.sendChatAlarm({
          user_id: userInfo.user_info.id,
          username: `${userInfo.user_info.first_name} ${userInfo.user_info.last_name}`,
        });
        console.log("New Chat is created.");
      });

      // 컴포넌트 언마운트 시 채널톡 종료
      return () => {
        ChannelService.shutdown();
      };
    }
  }, [userInfo]);

  return (
    <div className="bg-[#171717] h-screen flex flex-col">
      <Header onMenuClick={() => setMobileMenuOpen(true)} />
      <div className="rounded-t-[30px] w-full flex-1 flex shadow-[0px_-3px_3px_0_rgb(0_0_0_/_20%)] overflow-hidden bg-transparent">
        {/* 데스크톱: 사이드바로 항상 표시 */}
        <div className="hidden md:block flex-shrink-0">
          <Lnb isMobile={false} />
        </div>

        {/* 모바일: Drawer로 표시 (햄버거 메뉴 클릭 시에만 열림) */}
        <Drawer
          title="메뉴"
          placement="left"
          onClose={() => setMobileMenuOpen(false)}
          open={mobileMenuOpen}
          styles={{
            body: { padding: 0 },
          }}
          width={250}
        >
          <Lnb isMobile={true} onMenuClick={() => setMobileMenuOpen(false)} />
        </Drawer>

        {/* 메인 콘텐츠 영역 */}
        <div className="w-full bg-[#f5f5f5] p-8 md:p-[35px] overflow-auto [&_h2]:mb-14 flex flex-col flex-1 min-h-0 justify-between">
          <div>
            <Route exact path="/home" component={Router.Dashboard} />
            <Route
              exact
              path="/campaign/search"
              render={() =>
                userInfo?.user_info?.user_type === "brand" ? (
                  <div>
                    {(() => {
                      message.warning(
                        "브랜드 계정은 접근 권한이 없습니다. 로그인 페이지로 이동합니다."
                      );
                      localStorage.clear();
                      return <Redirect to="/signin" />;
                    })()}
                  </div>
                ) : (
                  <Router.CampaignSearch />
                )
              }
            />
            {userInfo?.user_info?.user_type === "brand" && (
              <>
                <Route
                  exact
                  path="/influencer/search"
                  component={Router.Search}
                />
                <Route
                  exact
                  path="/campaign/manage"
                  component={Router.CampaignManagement}
                />
                <Route
                  exact
                  path="/payments/return"
                  component={Router.PaymentReturn}
                />
                <Route
                  exact
                  path="/payments/brand-payments-history"
                  component={Router.BrandPaymentHistory}
                />
                <Route
                  exact
                  path="/payments/brand-payments-history/detail/:payReportId"
                  component={Router.BrandPaymentHistoryDetail}
                />
                <Route
                  exact
                  path="/campaign/settlement"
                  component={Router.Payout}
                />
                <Route
                  exact
                  path="/campaign/create"
                  component={Router.CreateCampaign}
                />
                <Route
                  exact
                  path="/workspace/info"
                  component={Router.CompanyInfo}
                />
                <Route
                  exact
                  path="/workspace/members-management"
                  component={Router.MembersManagement}
                />
              </>
            )}
            {userInfo?.user_info?.user_type === "agency" && (
              <>
                <Route
                  exact
                  path="/campaign/manage"
                  component={Router.CampaignManagement}
                />
                <Route
                  exact
                  path="/workspace/info"
                  component={Router.CompanyInfo}
                />
                <Route
                  exact
                  path="/workspace/members-management"
                  component={Router.MembersManagement}
                />
                <Route
                  exact
                  path="/workspace/creator-management"
                  component={Router.InfluencerManagement}
                />
                <Route
                  exact
                  path="/payments/agency-payments-history"
                  component={Router.AgencyPaymentHistory}
                />
                <Route
                  exact
                  path="/payments/agency-payments-history/:payReportId"
                  component={Router.AgencyPaymentHistoryDetail}
                />
              </>
            )}

            {userInfo?.user_info?.user_type === "influencer" && (
              <>
                <Route
                  exact
                  path="/campaign/manage"
                  component={Router.MyCampaign}
                />
                <Route
                  exact
                  path="/influencer/profile"
                  component={Router.InfluencerProfile}
                />
                <Route
                  exact
                  path="/influencer/dashboard"
                  component={Router.InfluencerDashboard}
                />
                <Route
                  exact
                  path="/payments/influencer-payments-history"
                  component={Router.InfluencerPaymentHistory}
                />
              </>
            )}
            <Route exact path="/mypage/profile" component={Router.Profile} />
            <Route exact path="/mypage/settings" component={Router.Setting} />
            <Route
              exact
              path="/mypage/invitations"
              component={Router.InfluencerInvitations}
            />

            <Route exact path="/membership" component={Router.Membership} />
            <Route exact path="/support" component={Router.Support} />
            <Route
              exact
              path="/support/notice/:id"
              component={Router.NoticeDetail}
            />
          </div>
          <Router.Footer />
        </div>
      </div>
      <Router.FloatChatButton
        channelMessengerOpen={channelMessengerOpen}
        setChannelMessengerOpen={setChannelMessengerOpen}
        userInfo={userInfo}
      />
    </div>
  );
};
